module.exports = __webpack_public_path__ + "img/1.114f5079.png";